module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_icon-w@2x-0b38b5f66687015277ad5c0b86fe86e2.png";